<template>
  <div class="foto-wrapper">
    
    <!-- Mode button -->
    <template v-if="isButton">
      <b-button
        :size="size"
        variant="pgiBtn"
        :class="buttonClass"
        @click="openModal"
      >
        <i class="fa fa-eye mr-1"></i>{{ buttonLabel || `Lihat ${withLength ? allPhotos.length + ' ' : ''}Foto` }}
      </b-button>
    </template>

    <!-- Mode thumbnail -->
    <template v-else>
      <div
        v-if="hasPhotos"
        class="foto-container"
        @click="openModal"
      >
        <b-img :src="photos[0]" fluid thumbnail class="main-photo" />
        <div class="overlay">
          <i class="fa fa-eye"></i>
          <span>Lihat Foto</span>
        </div>
      </div>
      <div v-else class="no-photo">Tidak ada foto</div>
    </template>

    <!-- Modal Foto -->
    <b-modal v-model="showModal" :title="title" size="lg" centered hide-footer>
      <div v-if="loading" class="text-center py-3">Memuat foto...</div>
      <div v-else-if="isError">
         <b-alert show variant="danger">
          Gagal memuat data. Mohon coba lagi nanti.
        </b-alert>
      </div>
      <div v-else-if="allPhotos.length > 0" class="gallery-wrapper">
        <div v-for="(photo, index) in allPhotos" :key="index" class="gallery-item">
          <a :href="photo" target="_blank">
            <b-img :src="photo" thumbnail fluid />
          </a>
        </div>
      </div>
      <div v-else class="text-center py-3">
        Tidak ada foto
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ModalFoto",
  props: {
    photos: {
      type: Array,
      default: () => [],
    },
    isButton: {
      type: Boolean,
      default: false,
    },
    apiUrl: {
      type: String,
      default: '',
    },
    withLength: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Foto',
    },
    size: {
      type: String,
      default: 'sm',
    },
    buttonClass: {
      type: String,
      default: '',
    },
    buttonLabel: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
      loading: false,
      isError: false,
      internalPhotos: [],
    };
  },
  computed: {
    hasPhotos() {
      return this.photos.length || this.internalPhotos.length;
    },
    allPhotos() {
      return this.internalPhotos.length ? this.internalPhotos : this.photos;
    },
  },
  methods: {
    async openModal() {
      this.showModal = true;
      if (this.apiUrl) {
        this.fetchPhotos();
      }
    },
    async fetchPhotos() {
      this.loading = true;
      this.isError = false;
      try {
        // const response = await this.$axios.get(this.apiUrl);
        await new Promise((resolve) => setTimeout(resolve, 1000));

        this.internalPhotos = [];
      } catch (err) {
        console.error("Gagal fetch foto:", err);
        this.isError = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.foto-wrapper {
  display: inline-block;
}
.foto-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.main-photo {
  width: 120px;
  height: 90px;
  object-fit: cover;
  border-radius: 6px;
}
.overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  transition: opacity 0.2s;
  border-radius: 6px;
}
.foto-container:hover .overlay {
  opacity: 1;
}

.gallery-wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  justify-items: center;
}

.no-photo {
  width: 120px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  color: #888;
  font-size: 12px;
  border-radius: 6px;
}

@media (max-width: 992px) {
  .gallery-wrapper {
    grid-template-columns: repeat(2, 1fr);
  }
  .gallery-item {
    width: 200px;
    height: 180px;
  }
}

@media (max-width: 576px) {
  .gallery-wrapper {
    grid-template-columns: 1fr;
  }
  .gallery-item {
    width: 100%;
    height: 180px;
  }
}
</style>
